export default {
  namespaced: true,
  state: {
    orderDetailsByDefault: {
      selectedLocation: null,
      selectedSeller: null
    },
    orderDetails: localStorage.getItem('orderDetails')
      ? JSON.parse(localStorage.getItem('orderDetails'))
      : {
          selectedLocation: null,
          selectedSeller: null,
          selectedClient: null
        },
    selectedBuyAgainPlanId: null
  },
  mutations: {
    setOrderDetailsByDefault(state, payload) {
      state.orderDetailsByDefault = payload;
    },
    setOrderDetails(state, payload) {
      state.orderDetails = payload;
    },
    setSelectedBuyAgainPlanId(state, payload) {
      state.selectedBuyAgainPlanId = payload;
    }
  },
  actions: {
    getOrderDetailsByDefault({ commit }, orderDetails) {
      commit('setOrderDetailsByDefault', orderDetails);
    },
    getOrderDetails({ commit }, orderDetails) {
      localStorage.setItem('orderDetails', JSON.stringify(orderDetails));
      commit('setOrderDetails', orderDetails);
    },
    clearOrderDetails({ dispatch, state }) {
      dispatch('getOrderDetails', {
        selectedLocation: state.orderDetailsByDefault.selectedLocation,
        selectedSeller: state.orderDetailsByDefault.selectedSeller,
        selectedClient: null
      });
    },
    getClientOrderDetails({ dispatch, state }, client) {
      dispatch('getOrderDetails', {
        selectedLocation: state.orderDetails.selectedLocation,
        selectedSeller: state.orderDetails.selectedSeller,
        selectedClient: client
      });
    },
    getSelectedBuyAgainPlanId({ commit }, selectedBuyAgainPlanId) {
      commit('setSelectedBuyAgainPlanId', selectedBuyAgainPlanId);
    }
  }
};
